export default class Validator {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        return !!(value.match(/^[1-9][0-9]{2}\s[0-9]{2}$/));
    }
}
